if (!customElements.get('cart-count')) {
  class CartCount extends HTMLElement {
    constructor() {
      super();

      this.updateRef = this.update.bind(this);
    }

    update(event) {
      if (!event.detail.html) return;

      this.innerHTML = event.detail.html;
    }

    disconnectedCallback() {
      document.removeEventListener('exo:cart-count-update', this.updateRef);
    }

    connectedCallback() {
      document.addEventListener('exo:cart-count-update', this.updateRef);
    }
  }

  customElements.define('cart-count', CartCount);
}
